import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiAbstraction } from './api.abstraction';

@Injectable()
export class UserHistoryLogApi extends ApiAbstraction {
  public constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  public getUserHistories(
    unitId: ID,
    filter: FilterUserHistoryDAO
  ): Observable<PaginatedResponseDAO<UserHistoryDAO> & { metadata: { cleanUpDate: string } }> {
    const params = new HttpParams({
      fromObject: {
        offset: filter.offset,
        limit: filter.limit,
        ...(filter.keyword && { keyword: filter.keyword }),
        ...(filter.methods && { methods: filter.methods }),
        ...(filter.fromDateAt && { fromDateAt: filter.fromDateAt }),
        ...(filter.toDateAt && { toDateAt: filter.toDateAt })
      }
    });
    return this.httpClient.get<PaginatedResponseDAO<UserHistoryDAO> & { metadata: { cleanUpDate: string } }>(
      `${this.baseUrl}/units/${unitId}/user-histories`,
      { params }
    );
  }

  public getUserHistoryById(unitId: ID, id: ID): Observable<UserHistoryDetailsDAO> {
    return this.httpClient.get<UserHistoryDetailsDAO>(`${this.baseUrl}/units/${unitId}/user-histories/${id}`);
  }
}
